<template>
  <div class="transaction-container">
    <Header />
    <Nothing />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Nothing from '@/components/Nothing.vue';

export default {
  components: {
    Header,
    Nothing
  }
};
</script>

<style>
.transaction-container {
  width: 100%;
  margin: 0 auto;
}
</style>
